import { Component, Input, OnInit } from '@angular/core';
import {
  DEFAULT_LANGUAGE_CODE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
} from '@app/shared/constants/language.contant';
import {
  EnvConfigService,
  ISupportedLanguage,
  OidcAuthService,
  StorageService,
} from 'ngx-mat-esign360';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-main-layout-menu',
  templateUrl: './main-layout-menu.component.html',
  styleUrls: ['./main-layout-menu.component.scss'],
})
export class MainLayoutMenuComponent implements OnInit {
  @Input() color = 'default';
  supportedLanguages: ISupportedLanguage[] = SUPPORTED_LANGUAGES;

  constructor(
    public authService: OidcAuthService,
    private storageService: StorageService,
    public translate: TranslateService,
    private envConfig: EnvConfigService
  ) {}

  ngOnInit(): void {}

  getActiveLanguage(): string {
    const defaultLanguage = this.envConfig.data.defaultLang
      ? this.envConfig.data.defaultLang
      : DEFAULT_LANGUAGE_CODE;
    return this.storageService.getData(LANGUAGE_STORAGE_KEY) ?? defaultLanguage;
  }

  getLanguageName(countryCode: string): string {
    const foundLanguageName = this.supportedLanguages.find(
      (language) => language.countryCode === countryCode
    ).language;

    if (!foundLanguageName) {
      console.error(`Language with country code "${countryCode}" was not found`);
    }

    return foundLanguageName;
  }

  onLanguageSelected(languageCode: string): void {
    this.translate.use(languageCode);
  }

  onLogout() {
    this.authService.logout();
  }
}
